function App() {
  return (
    <div className="space-y-4 border border-[#d4d4d4] bg-[#fefefe] shadow rounded-md p-20">
      <div>
        Here are some resources I used as an undergrad to find and apply to STEM
        research internships. Most, if not all, accept international students
        🙂.
      </div>
      <ul className="space-y-2">
        <li>
          <a
            className="text-blue-700"
            href="https://www.pathwaystoscience.org/"
          >
            Pathways To Science
          </a>
        </li>
        <li>
          <a
            className="text-blue-700"
            href="https://www.bcm.edu/education/graduate-school-of-biomedical-sciences/programs/diversity/smart-program"
          >
            Baylor College of Medicine SMART Program
          </a>
        </li>
        <li>
          <a
            className="text-blue-700"
            href="https://www.czbiohub.org/sf/summer-internships/"
          >
            Chan Zuckerburg Biohub
          </a>
        </li>
        <li>
          <a
            className="text-blue-700"
            href="https://uwaterloo.ca/institute-for-quantum-computing/useqip"
          >
            Undergraduate School on Experimental Quantum Information Processing
            (USEQIP)
          </a>
        </li>
        <li>
          <a className="text-blue-700" href="https://riss.ri.cmu.edu/apply/">
            Robotics Institute Summer Scholars (RISS)
          </a>
        </li>
        <li>
          <a
            className="text-blue-700"
            href="https://alleninstitute.org/careers/internships-and-postbac/"
          >
            Allen Institute
          </a>
        </li>
        <li>
          <a className="text-blue-700" href="https://allenai.org/internships">
            Allen Institute for AI
          </a>
        </li>
        <li>
          <a className="text-blue-700" href="https://oge.mit.edu/msrp/">
            MIT Summer Research Program (MSRP)
          </a>
        </li>
      </ul>
    </div>
  );
}

export default App;
